import React from 'react';
import axiosInstance from '../axiosInstance';

/**
 * ProxiedImage component that uses the image proxy for external images
 * This ensures that images from external sources like IGDB are loaded through our proxy
 */
const ProxiedImage = ({ src, alt, style, className, onError, onClick, ...otherProps }) => {
  // Use our axiosInstance to get the proper URL (which will use the proxy for external images)
  const proxiedSrc = src ? axiosInstance.getImageUrl(src) : '';
  
  // Default error handler if none provided
  const handleError = (e) => {
    if (onError) {
      onError(e);
    } else {
      // Default fallback
      e.target.onerror = null;
      e.target.src = 'https://placehold.co/600x400?text=No+Image';
    }
  };
  
  return (
    <img 
      src={proxiedSrc}
      alt={alt || 'Image'}
      style={style}
      className={className}
      onClick={onClick}
      onError={handleError}
      {...otherProps}
    />
  );
};

export default ProxiedImage;
